import { Features } from '../interfaces';
import { FeatureState } from '@outlaw/core';
import { OutlawCommunityConfig } from '../outlaw-community.config';

export function getCommunityFeatureFlags(config: Partial<OutlawCommunityConfig>): Features {
  const featureFlags = config.featureFlags || {};

  return {
    ...featureFlags,
    comments: featureFlags.comments || FeatureState.disabled,
    paidPosts: featureFlags.paidPosts || FeatureState.disabled,
    openProfileInNewWindow: featureFlags.openProfileInNewWindow || FeatureState.disabled,
    newPlaylist: featureFlags.newPlaylist || FeatureState.disabled,
    communityInApp: featureFlags.communityInApp || FeatureState.disabled,
    paywall: featureFlags.paywall || FeatureState.disabled,
    showRecommendationMessage: featureFlags.showRecommendationMessage || FeatureState.disabled,
    showProfileLinksInRecommendedByDialog: featureFlags.showProfileLinksInRecommendedByDialog || FeatureState.enabled,
    showWidgets: featureFlags.showWidgets || FeatureState.disabled,
    showThemeToggle: featureFlags.showThemeToggle || FeatureState.disabled,
    selections: featureFlags.selections || FeatureState.disabled,
  };
}
